<template>
  <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
    <template slot="header">
      <div class="col-8">
        <h4 class="card-title">Kişi Bazlı Performans</h4>
        <p class="card-category">Kim kaç kumbara boşaltmış, en son ne zaman giriş yapmış</p>
      </div>
      <div style="text-align: right;" class="col-4 card-title">
        <a-button icon="download" @click="exportCsv" :disabled="!rows.length">
          Excel'e Aktar
        </a-button>
      </div>
    </template>
    <a-table rowKey="user_id" :columns="columns" :data-source="rows" :pagination="{ pageSize: 10 }">
      <span slot="last_login" slot-scope="text, record">
        {{ formatDate(record.last_login) }}
      </span>
    </a-table>
  </card>
</template>

<script>
import { mapState } from 'vuex'
import Card from 'src/components/Cards/Card.vue'

export default {
  components: { Card },
  computed: {
    ...mapState({
      rows: (state) => state.Reports.user_performance,
    }),
  },
  mounted() {
    this.$store.dispatch('Reports/requestUserPerformance')
  },
  methods: {
    formatDate(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('tr-TR')
    },
    exportCsv() {
      this.$exportToCsv(
        'kisi_bazli_performans',
        [
          { title: 'İsim', key: 'first_name' },
          { title: 'Soyisim', key: 'last_name' },
          { title: 'Email', key: 'email' },
          { title: 'Boşaltma Sayısı', key: 'unload_count' },
          { title: 'Son Giriş', key: 'last_login' },
        ],
        this.rows.map((r) => ({ ...r, last_login: this.formatDate(r.last_login) }))
      )
    },
  },
  data() {
    return {
      columns: [
        { title: 'İsim', dataIndex: 'first_name', key: 'first_name' },
        { title: 'Soyisim', dataIndex: 'last_name', key: 'last_name' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        { title: 'Boşaltma Sayısı', dataIndex: 'unload_count', key: 'unload_count' },
        { title: 'Son Giriş', key: 'last_login', scopedSlots: { customRender: 'last_login' } },
      ],
    }
  },
}
</script>
